export const FILTER_SET_SEARCH = 'FILTER_SET_SEARCH';
export const FILTER_SET_DIETARY = 'FILTER_SET_DIETARY';
export const FILTER_SET_SORT = 'FILTER_SET_SORT';
export const FILTER_SET_CATEGORY = 'FILTER_SET_CATEGORY';
export const FILTER_SET_MASTER_CATEGORY = 'FILTER_SET_MASTER_CATEGORY';
export const FILTER_SET_OPENED_INDEX = 'FILTER_SET_OPENED_INDEX';
export const FILTER_SET_SELECTED_STORE = 'FILTER_SET_SELECTED_STORE';
export const FILTER_RESET = 'FILTER_RESET';
export const FILTERS = 'FILTERS';

export const CATALOG_LOAD_STORE = 'CATALOG_LOAD_STORE';
export const CATALOG_LOAD_ALL = 'CATALOG_LOAD_ALL';
export const CATALOG_CLEAR_STORE = 'CATALOG_CLEAR_STORE';
export const CATALOG_CLEAR_ALL = 'CATALOG_CLEAR_ALL';
